import React from 'react';
import {
  Card,
  CardHeader,
  CardBody,
  FormGroup,
  Label,
  InputGroup,
  InputGroupAddon,
  Input,
  Button,
} from 'reactstrap';
import SpeakerForm from '../../SpeakerForm';
import SelectedSpeakers from './SelectedSpeakers';

/*
 * Speaker picker for event-category programs. `selectedSpeakerId` is an
 * index into the speakers list ('none' when nothing picked), matching the
 * legacy behavior.
 */
const SpeakersSection = ({
  speakers,
  selectedSpeakerId,
  onSelectSpeaker,
  onAddSpeaker,
  selectedSpeakerList,
  onDeleteSpeaker,
  onActionSpeaker,
  speakerFormOpen,
  speakerFormEdit,
  speakerData,
  getSpeakers,
}) => {
  return (
    <Card className="my-4">
      <CardHeader>
        Speaker
        <Button
          size="sm"
          className="float-right"
          onClick={() => onActionSpeaker(false)}
        >
          +Create
        </Button>
      </CardHeader>
      <CardBody>
        <FormGroup className="mb-2">
          <Label
            for="form-select-speaker"
            className="text-gray font-weight-bold"
          >
            Select Speaker
          </Label>
          <InputGroup>
            <Input
              type="select"
              value={selectedSpeakerId}
              id="speakerselect"
              onChange={({ target }) => onSelectSpeaker(target.value)}
            >
              <option value="none" disabled hidden>
                Pilih Speaker
              </option>
              {speakers.map((item, index) => (
                <option key={`speaker${item.id}`} value={index}>
                  {item.name}
                </option>
              ))}
            </Input>
            <InputGroupAddon addonType="append">
              <Button
                onClick={onAddSpeaker}
                disabled={selectedSpeakerId === 'none'}
                color="success"
              >
                Add
              </Button>
            </InputGroupAddon>
          </InputGroup>
        </FormGroup>

        <SelectedSpeakers
          speakers={selectedSpeakerList}
          onDelete={onDeleteSpeaker}
          onActionSpeaker={onActionSpeaker}
          listSpeakers={speakers}
        />
      </CardBody>
      <SpeakerForm
        isOpen={speakerFormOpen}
        toggle={onActionSpeaker}
        refresh={getSpeakers}
        isEdit={speakerFormEdit}
        speakerData={speakerData}
      />
    </Card>
  );
};

export default SpeakersSection;
